var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('emc-table-icon-download-base',{attrs:{"type":_vm.type,"item":_vm.item,"color":_vm.color,"icon":_vm.icon,"tool-tip":_vm.toolTip,"url":_vm.url,"disabled":_vm.disabled,"textButton":_vm.textButton}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }